import { gql } from "@apollo/client";

export const GET_GA_ACCOUNTS = gql`
  query GetGaAccounts($email: String) {
    gaAccounts(email: $email) {
      success
      accounts
    }
  }
`;

export const GET_GA_PROPERTIES = gql`
  query GetGaProperties($email: String, $account_id: String) {
    gaProperties(email: $email, account_id: $account_id) {
      success
      properties
    }
  }
`;

export const GET_GA_ANALYTICS_OVERVIEW = gql`
  query GetGaAnalyticsOverview($property_id: String!, $start_date: String, $end_date: String, $email: String) {
    gaAnalyticsOverview(property_id: $property_id, start_date: $start_date, end_date: $end_date, email: $email) {
      success
      data
    }
  }
`;

export const GET_GA_ANALYTICS_TRENDS = gql`
  query GetGaAnalyticsTrends($property_id: String!, $start_date: String, $end_date: String, $email: String) {
    gaAnalyticsTrends(property_id: $property_id, start_date: $start_date, end_date: $end_date, email: $email) {
      success
      data
    }
  }
`;

export const GET_GA_TOP_PAGES = gql`
  query GetGaTopPages($property_id: String!, $start_date: String, $end_date: String, $limit: Int, $email: String) {
    gaTopPages(property_id: $property_id, start_date: $start_date, end_date: $end_date, limit: $limit, email: $email) {
      success
      data
    }
  }
`;

export const GET_GA_TRAFFIC_SOURCES = gql`
  query GetGaTrafficSources($property_id: String!, $start_date: String, $end_date: String, $limit: Int, $email: String) {
    gaTrafficSources(property_id: $property_id, start_date: $start_date, end_date: $end_date, limit: $limit, email: $email) {
      success
      data
    }
  }
`;

export const GET_GA_DEVICES = gql`
  query GetGaDevices($property_id: String!, $start_date: String, $end_date: String, $email: String) {
    gaDevices(property_id: $property_id, start_date: $start_date, end_date: $end_date, email: $email) {
      success
      data
    }
  }
`;

export const GET_GA_COUNTRIES = gql`
  query GetGaCountries($property_id: String!, $start_date: String, $end_date: String, $limit: Int, $email: String) {
    gaCountries(property_id: $property_id, start_date: $start_date, end_date: $end_date, limit: $limit, email: $email) {
      success
      data
    }
  }
`;

export const GET_GA_DASHBOARD = gql`
  query GetGaDashboard($property_id: String!, $start_date: String, $end_date: String, $email: String) {
    gaDashboard(property_id: $property_id, start_date: $start_date, end_date: $end_date, email: $email) {
      success
      data
    }
  }
`;

export const AUTHORIZE_GA = gql`
  query AuthorizeGa {
    authorizeGa {
      authorization_url
      state
    }
  }
`;

export const GET_GA_AUTH_STATUS = gql`
  query GetGaAuthStatus($email: String) {
    gaAuthStatus(email: $email) {
      status
    }
  }
`;

export const GET_GA_CLIENT_ID = gql`
  query GetGaClientId {
    gaClientId {
      client_id
      redirect_uri
      note
    }
  }
`;
